import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import fn from '../../Functii';
import { acPopVizibil } from "../actions/acPopVizibil";
// import lottie from 'lottie-web';
// import animationData from '../../lottie/snoww.json';
// let animObj = null;

class PopWidgetClasamentLastResults extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  // componentDidMount() {
  //   if(this.animBox2) {
  //       animObj = lottie.loadAnimation({
  //           container: this.animBox2, // the dom element that will contain the animation
  //           renderer: 'svg',
  //           loop: true,
  //           autoplay: true,
  //           animationData: animationData // the path to the animation json
  //         });
  //   }
  // }

  popHead() {
    return (
      <div className="con-title module-header1">
        <div className="popup-title">
          <span>{this.props.multiLang.cursaLoteriilor.txt + ' - ' + this.props.multiLang.clasamentSaptAnterioara.txt}</span>
          <span onClick={this.closePop.bind(this)}>x</span>
        </div>
      </div>
    );
  }
  popBody() {
    var tr = [];
    if (this.props.widgetPromotie && this.props.widgetPromotie.lastResults && this.props.widgetPromotie.lastResults.length > 15) {
      let clasament = this.props.widgetPromotie.lastResults
      for (const poz in clasament) {
        tr.push(
          <tr key={poz}>
            <td>{clasament[poz]["nr. crt."]}</td>
            <td>{clasament[poz]['username']}</td>
            <td>{clasament[poz]['points']}</td>
            <td>{clasament[poz]['prize'] + ' RON'}</td>
          </tr>
        )
      }
    }
    var tabel = (
      <table className="clasament scroll_content">
        <tbody>{tr}</tbody>
      </table>
    );
    return [
      <div key="lottieAnimation" className="lottieAnimation">
        <div ref={(f) => this.animBox2 = f}></div>
      </div>,
      <table key="header" className="clasament header">
        <thead>
          <tr>
            <th>{this.props.multiLang.loc.txt}</th>
            <th>{this.props.multiLang.user.txt}</th>
            <th>{this.props.multiLang.points.txt}</th>
            <th>{this.props.multiLang.prize.txt}</th>
          </tr>
        </thead>
      </table>,
      <div key="con-clasament" className="con-clasament">{tabel}</div>
    ]
  }
  closePop() {
    this.props.acPopVizibil({ popVizibil: false });
  }
  render() {
    return (
      <div className="popUp-Content clasament">
        <div className="runde-child">
          {this.popHead()}
          <div className="leaderboardRules ">
          <div className='title'>{this.props?.widgetPromotie?.total_prize_value ? (fn.points(parseInt(this.props.widgetPromotie.total_prize_value)) + ' ' + this.props.defaultVal.currency + ' ' + this.props.multiLang.premiiCash.txt): null}</div>
          </div>
          {this.popBody()}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    popVizibil: state.popVizibil,
    multiLang: state.multiLang,
    widgetPromotie: state.widgetPromotie,
    defaultVal: state.defaultVal
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      acPopVizibil: acPopVizibil
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(PopWidgetClasamentLastResults);
